import { getRisingUserInfo } from "@/api/authToken";
export default {
    namespaced:true,
    state:{
        userInfo:{
        },
        botInfo: {
        },
        risingUserInfo:{
        },
        chartInfo: {

        },
        gridbotInfo : {
            isActive   : false,
            isRegister : false,
            isEdit     : false,
            data       : {},
        },
        activeStatus:false,
        registerStatus:false,
        editStatus:true,
        acess:''
    },
    mutations:{
        setUserInfo(state,val){
            state.userInfo = val
        },
        setBotInfo(state,val){
            state.botInfo = val
        },
        setAcitve(state,val){
            state.activeStatus = val
        },
        setRegister(state,val){
            state.registerStatus = val
        },
        setEdit(state,val){
            state.editStatus = val
        },
        setApiKey(state,val){
            // console.log(state.botInfo);
            state.botInfo.apikey = val
        },
        setRisingUserInfo(state,val){
            state.risingUserInfo = val;
        },
        setChartInfo(state,val){
            state.chartInfo = val
        },
        setAcess(state, val){
            state.acess = val
        },
        setGridbotInfo(state,payload){
            state.gridbotInfo = {
                ...state.gridbotInfo,
                ...payload
            } 
            console.log(state.gridbotInfo);
        }
    },
    actions : {
        getChartSubscribeInfo({commit},payload){
            // console.log('get chart subscribe info ',payload);
            commit('setRisingUserInfo',payload)
            commit('setChartInfo',payload.chart)
        },
        async fetchUser({dispatch}) {
            try {
                // const config = useRuntimeConfig();
                // const secureOption = {};
                // if(config.public.cookieDomain && config.public.env === ENV_PRODUCTION) {
                //     secureOption.secure = true;
                // }

                // const cookie = useCookie("X_RID_AUT", {
                //     path     : "/",
                //     maxAge   : 60 * 30,
                //     // sameSite : "lax",
                //     // domain   : config.public.cookieDomain || '',
                //     // ...secureOption
                // });
                // console.log('use user store fetch user x_rid_aut ',cookie.value);
                
                // if (!cookie.value) {
                //     await this.clearUserInfo();
                //     return;
                // }

                // const {error, data} = await useFetch(`${baseUrl}/user/info`, {
                //     method: "get",
                //     headers: {
                //         cookie: `RID_AUT=${cookie.value}`,
                //         session_id:cookie.value
                //     },
                //     credentials: "include",
                // });
                const {error,data} = await getRisingUserInfo(); 
                // console.log('data',data);
                if (data) await dispatch("getChartSubscribeInfo", data);
                else {
                    await dispatch('clearUserInfo');
                }
            } catch (e) {
                await dispatch('clearUserInfo');
            }
        },
        clearUserInfo({commit}){
            commit('setRisingUserInfo',null)
            commit('setChartInfo',null)
        }
    },
    getters: {
        // getChartSubscribeInfo(state){
        //     let {favorites_list ,chart } = state.risingUserInfo;
        //     console.log('{favorites_list ,chart }',{favorites_list ,chart });
        //     return {favorites_list ,chart}
        // },
        favoriteList(state){
            return state.risingUserInfo.favorites_list.map(ob => ob);
        },
        chartCoinList(state){
            return state.chartInfo.chart_coin_list;
        }
    },
}